import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import Draggable from 'react-draggable';
import { MOBILE_ELEMS } from './Timeline._constants';
import { getYearDetailsByIndex, getIndexByYearDetails } from './Timeline._helpers';
const ContainerListContainer = styled.div `
  flex: 1;
  position: relative;
  /* added for draggable changes */;
  ${(props) => `max-width: ${props.contentWidth - 56}px`};
`;
const ContainerList = styled.ul `
  margin: 0;
  position: relative;
  display: inline-flex;
  align-items: stretch;
  height: 76px;
  padding-left: 0;
  list-style-type: none;
  cursor: draggable;
`;
const ContainerListFiller = styled.li `
  width: ${(props) => `${props.yearWidth}px`};
  cursor: grab;
  cursor: move;
  cursor: -moz-grab;
  cursor: -webkit-grab;
`;
const TimelineTimelineMobileDraggable = ({ children, className, containerID, contentWidth, yearWidth, years, noYears, handleUseClick, clickYear, }) => {
    const TWEAK = 10;
    const initBounds = { top: 0, right: 0, bottom: 0, left: 0 };
    let maxWidthFromYears;
    const dragRef = useRef(null);
    const [setBounds, setSetBounds] = useState(initBounds);
    const [position, setPosition] = useState({ x: 0, y: 0 });
    useEffect(() => {
        maxWidthFromYears = (noYears - 1) * yearWidth;
        const bounds = Object.assign(Object.assign({}, initBounds), { left: -1 * maxWidthFromYears - TWEAK / 2, right: TWEAK / 2 });
        setSetBounds(bounds);
    }, [yearWidth]);
    useEffect(() => {
        const clickYearIndex = getIndexByYearDetails(years, clickYear);
        setPosition({ x: -(yearWidth * clickYearIndex), y: 0 });
    }, [clickYear]);
    const handleDrag = (evt, position) => {
        const currentWidth = Math.abs(position.deltaX).toFixed(1);
        const lastPosition = Math.abs(position.lastX).toFixed(1);
        const newPosition = Math.abs(position.x || 0).toFixed(1);
        if (lastPosition === newPosition) {
            return;
        }
        if (yearWidth !== parseFloat(currentWidth)) {
            return;
        }
        const newIndex = Math.round(newPosition / currentWidth);
        const yearDetails = getYearDetailsByIndex(years, newIndex);
        handleUseClick(yearDetails.year, yearDetails.id);
        evt.preventDefault();
    };
    return (React.createElement(Draggable, { disabled: false, bounds: setBounds, grid: [yearWidth, 0], onDrag: handleDrag, position: position },
        React.createElement(ContainerListContainer, { ref: dragRef, id: containerID, contentWidth: contentWidth },
            React.createElement(ContainerList, null,
                React.createElement(ContainerListFiller, { yearWidth: yearWidth, className: `${className} ${MOBILE_ELEMS.DRAG_PREFIX}left-2` }),
                React.createElement(ContainerListFiller, { yearWidth: yearWidth, className: `${className} ${MOBILE_ELEMS.DRAG_PREFIX}left-1` }),
                children,
                React.createElement(ContainerListFiller, { yearWidth: yearWidth, className: `${className} ${MOBILE_ELEMS.DRAG_PREFIX}right-1` }),
                React.createElement(ContainerListFiller, { yearWidth: yearWidth, className: `${className} ${MOBILE_ELEMS.DRAG_PREFIX}right-2` })))));
};
export default TimelineTimelineMobileDraggable;
